import { net } from './pb';

import GameSocket from './IMGameSocket';
import { BinaryEncoder } from './IMBinaryUtils';
import StringUtils from './IMStringUtils';
import S2C from './IMS2C';
import IMApp from './IMApp';


export default class C2S {
  static testS2C = new S2C();
  /**
   * 发送心跳包
   */
  static msg_heart_test() {
    var msg = new net.msg_heart_test();
    msg.svr_time = 1;
    let buffer = net.msg_heart_test.encode(msg).finish();
    GameSocket.instance.sendData(net.CLIENT_MSG_ID.C2S_MSG_HEART, buffer);
  }


  static msg_h5login_req(uid, key) {
    var msg = new net.msg_h5login_req();
    msg.uid = uid;
    msg.fastkey = BinaryEncoder.fromString(key);
    msg.deviceid = StringUtils.encode(IMApp.deviceid);
    msg.version = StringUtils.encode(IMApp.version);
    let buffer = net.msg_h5login_req.encode(msg).finish();
    GameSocket.instance.sendData(net.CLIENT_MSG_ID.C2S_MSG_H5LOGIN, buffer);
  }

  /**
   * 登录到游戏server
   * @param uid 从php获取的用户ID
   * @param key 从php获取的用户Sessionkey
   */
  static msg_login_req(uid, key, phone) {
    var msg = new net.msg_login_req();
    msg.uid = uid;
    msg.fastkey = BinaryEncoder.fromString(key);
    msg.phonenum = BinaryEncoder.fromString(phone);
    msg.deviceid = StringUtils.encode(IMApp.deviceid);
    msg.version = StringUtils.encode(IMApp.version);
    let buffer = net.msg_login_req.encode(msg).finish();
    GameSocket.instance.sendData(net.CLIENT_MSG_ID.C2S_MSG_LOGIN, buffer);
  }

  static msg_add_friend_byfid(fid, hellomsg) {
    var msg = new net.msg_add_friend_byfid();
    msg.fid = fid;
    msg.hellomsg = StringUtils.encode(hellomsg);
    let buffer = net.msg_add_friend_byfid.encode(msg).finish();
    GameSocket.instance.sendData(net.CLIENT_MSG_ID.C2S_MSG_ADD_FRIEND_BYFID, buffer);
  }

  static msg_get_user_info(phonenum, uid, fid) {
    // phonenum = '4';
    // uid = 0;
    var msg = new net.msg_get_user_info();
    msg.phonenum = BinaryEncoder.fromString(phonenum ? phonenum : '');
    msg.uid = uid;
    msg.fid = fid;
    // console.log(
    //   'msg.fid--->',
    //   msg.fid,
    //   'msg.uid--->',
    //   msg.uid,
    //   'phonenum-->',
    //   phonenum,
    // );
    let buffer = net.msg_get_user_info.encode(msg).finish();
    GameSocket.instance.sendData(
      net.CLIENT_MSG_ID.C2S_MSG_GET_USER_INFO,
      buffer,
    );
  }

  static msg_add_friend(phonenum, hellomsg) {
    var msg = new net.msg_add_friend();
    msg.phonenum = StringUtils.encode(phonenum);
    msg.hellomsg = StringUtils.encode(hellomsg);
    let buffer = net.msg_add_friend.encode(msg).finish();
    GameSocket.instance.sendData(net.CLIENT_MSG_ID.C2S_MSG_ADD_FRIEND, buffer);
  }

  static msg_handle_friend_apply(otheruid, handletype) {
    var msg = new net.msg_handle_friend_apply();
    msg.otheruid = otheruid;
    msg.handletype = handletype;
    let buffer = net.msg_handle_friend_apply.encode(msg).finish();
    GameSocket.instance.sendData(
      net.CLIENT_MSG_ID.C2S_MSG_HANDLE_FRIEND_APPLY,
      buffer,
    );
  }

  static msg_friend_apply_list() {
    var msg = new net.msg_friend_apply_list();
    let buffer = net.msg_friend_apply_list.encode(msg).finish();
    GameSocket.instance.sendData(
      net.CLIENT_MSG_ID.C2S_MSG_FRIEND_APPLY_LIST,
      buffer,
    );
  }

  static msg_friend_list() {
    var msg = new net.msg_get_friend_incr_list();
    msg.version = IMApp.friendlistversion;
    let buffer = net.msg_get_friend_incr_list.encode(msg).finish();
    GameSocket.instance.sendData(
      net.CLIENT_MSG_ID.C2S_MSG_GET_FRIEND_INCR_LIST,
      buffer,
    );
  }

  static msg_send_private_msg(recvuid, msg_type, content, isGroup = false, clientkey = '', authcode = '', nopush = 0) {
    let msg = isGroup ? new net.msg_send_group_msg() : new net.msg_send_private_msg();
    isGroup ? (msg.groupkey = recvuid) : (msg.recvuid = IMApp.getOtherId(recvuid, IMApp.user.uid,));
    msg.msg_type = msg_type;
    msg.content = StringUtils.encode(content);
    msg.clientkey = StringUtils.encode(clientkey);
    msg.snaptime = IMApp.getSnapTime(recvuid);
    msg.authcode = authcode;
    msg.nopush = nopush;
    let buffer = (isGroup ? net.msg_send_group_msg : net.msg_send_private_msg)
      .encode(msg)
      .finish();

    GameSocket.instance.sendData(
      isGroup ? net.CLIENT_MSG_ID.C2S_MSG_SEND_GROUP_MSG : net.CLIENT_MSG_ID.C2S_MSG_SEND_PRIVATE_MSG,
      buffer,
      IMApp.getCurTime(),
    );
    return msg;
  }


  static msg_get_msg_list(chatkey, chatmsgno) {
    var msg = new net.msg_get_msg_list();
    msg.chatkey = chatkey;
    msg.chatmsgno = chatmsgno < 0 ? 0 : chatmsgno;
    let buffer = net.msg_get_msg_list.encode(msg).finish();
    GameSocket.instance.sendData(net.CLIENT_MSG_ID.C2S_MSG_GET_MSG_LIST, buffer);
  }

  static msg_confirm_read_msg(chatkey, chatmsgno) {
    var msg = new net.msg_confirm_read_msg();
    msg.chatkey = chatkey;
    msg.chatmsgno = chatmsgno;
    let buffer = net.msg_confirm_read_msg.encode(msg).finish();
    GameSocket.instance.sendData(
      net.CLIENT_MSG_ID.C2S_MSG_CONFIRM_READ_MSG,
      buffer,
    );
  }

  static msg_create_group_chat(uids, opertm) {
    if (IMApp.isAlone) {
      let t = new net.msg_create_group_chat_rep();
      t.uids = uids;
      t.groupkey = 12345;
      C2S.testS2C.msg_create_group_chat_rep(
        net.msg_create_group_chat_rep.encode(t).finish(),
      );
      return;
    }
    var msg = new net.msg_create_group_chat();
    msg.uids = uids;
    msg.opertm = opertm;
    let buffer = net.msg_create_group_chat.encode(msg).finish();
    GameSocket.instance.sendData(
      net.CLIENT_MSG_ID.C2S_MSG_CREATE_GROUP_CHAT,
      buffer,
    );
  }

  static msg_get_group_info(groupkey, is_stranger = 0, is_end = 1) {
    var msg = new net.msg_get_group_info();
    msg.groupkey = groupkey;
    msg.is_stranger = is_stranger;
    msg.is_end = is_end;
    let buffer = net.msg_get_group_info.encode(msg).finish();
    GameSocket.instance.sendData(
      net.CLIENT_MSG_ID.C2S_MSG_GET_GROUP_INFO,
      buffer,
    );
  }

  static msg_add_group_member(groupkey, uids) {
    var msg = new net.msg_add_group_member();
    msg.groupkey = groupkey;
    msg.uids = uids;
    let buffer = net.msg_add_group_member.encode(msg).finish();
    GameSocket.instance.sendData(
      net.CLIENT_MSG_ID.C2S_MSG_ADD_GROUP_MEMBER,
      buffer,
    );
  }

  static msg_del_group_member(groupkey, uids) {
    var msg = new net.msg_del_group_member();
    msg.groupkey = groupkey;
    msg.uids = uids;
    let buffer = net.msg_del_group_member.encode(msg).finish();
    GameSocket.instance.sendData(
      net.CLIENT_MSG_ID.C2S_MSG_DEL_GROUP_MEMBER,
      buffer,
    );
  }

  static msg_modify_groupname(groupkey, new_name) {
    var msg = new net.msg_modify_groupname();
    msg.groupkey = groupkey;
    msg.new_name = StringUtils.encode(new_name);
    let buffer = net.msg_modify_groupname.encode(msg).finish();
    GameSocket.instance.sendData(
      net.CLIENT_MSG_ID.C2S_MSG_MODIFY_GROUPNAME,
      buffer,
    );
  }

  static msg_modify_groupnotify(groupkey, new_notify) {
    var msg = new net.msg_modify_groupnotify();
    msg.groupkey = groupkey;
    msg.new_notify = StringUtils.encode(new_notify);
    let buffer = net.msg_modify_groupnotify.encode(msg).finish();
    GameSocket.instance.sendData(
      net.CLIENT_MSG_ID.C2S_MSG_MODIFY_GROUPNOTIFY,
      buffer,
    );
  }

  static msg_del_groupadmin(groupkey, uids) {
    var msg = new net.msg_del_groupadmin();
    msg.groupkey = groupkey;
    msg.uids = uids;
    let buffer = net.msg_del_groupadmin.encode(msg).finish();
    GameSocket.instance.sendData(
      net.CLIENT_MSG_ID.C2S_MSG_DEL_GROUPADMIN,
      buffer,
    );
  }

  static msg_set_groupadmin(groupkey, uids) {
    var msg = new net.msg_set_groupadmin();
    msg.groupkey = groupkey;
    msg.uids = uids;
    let buffer = net.msg_set_groupadmin.encode(msg).finish();
    GameSocket.instance.sendData(
      net.CLIENT_MSG_ID.C2S_MSG_SET_GROUPADMIN,
      buffer,
    );
  }

  /**
   *
   * @param {*} groupkey
   * @param {*} limits  1群主可设置 2管理员可设置 3全员可设置
   */
  static msg_set_groupinfo_limits(groupkey, limits) {
    var msg = new net.msg_set_groupinfo_limits();
    msg.groupkey = groupkey;
    msg.limits = limits;
    let buffer = net.msg_set_groupinfo_limits.encode(msg).finish();
    GameSocket.instance.sendData(
      net.CLIENT_MSG_ID.C2S_MSG_SET_GROUPINFO_LIMITS,
      buffer,
    );
  }

  /**
   *
   * @param {*} groupkey
   * @param {*} limits  1群主可查看 2管理员可查看 3全员可查看
   */
  static msg_set_grouplook_limits(groupkey, limits) {
    var msg = new net.msg_set_grouplook_limits();
    msg.groupkey = groupkey;
    msg.limits = limits;
    let buffer = net.msg_set_grouplook_limits.encode(msg).finish();
    GameSocket.instance.sendData(
      net.CLIENT_MSG_ID.C2S_MSG_SET_GROUPLOOK_LIMITS,
      buffer,
    );
  }

  /**
   *
   * @param {*} groupkey
   * @param {*} limits  1群主和管理员可审核 0无需要审核
   */
  static msg_set_groupadd_limits(groupkey, limits) {
    var msg = new net.msg_set_groupadd_limits();
    msg.groupkey = groupkey;
    msg.limits = limits;
    let buffer = net.msg_set_groupadd_limits.encode(msg).finish();
    GameSocket.instance.sendData(
      net.CLIENT_MSG_ID.C2S_MSG_SET_GROUPADD_LIMITS,
      buffer,
    );
  }

  static msg_set_grouphost(groupkey, uid) {
    var msg = new net.msg_set_grouphost();
    msg.groupkey = groupkey;
    msg.uid = uid;
    let buffer = net.msg_set_grouphost.encode(msg).finish();
    GameSocket.instance.sendData(
      net.CLIENT_MSG_ID.C2S_MSG_SET_GROUPHOST,
      buffer,
    );
  }

  static get_room_history_msg(roomkey) {
    //获取房间的聊天记录
    var msg = new net.msg_get_chatroom_history_msg();
    msg.roomkey = roomkey;
    let buffer = net.msg_get_chatroom_history_msg.encode(msg).finish()
    GameSocket.instance.sendData(net.CLIENT_MSG_ID.C2S_MSG_GET_CHATROOM_HISTORY_MSG, buffer);
  }

  static msg_get_redbag(redbag_id) {
    console.log('--------->领红包id=', redbag_id);
    var msg = new net.msg_get_redbag();
    msg.redbag_id = redbag_id;
    let buffer = net.msg_get_redbag.encode(msg).finish();
    GameSocket.instance.sendData(net.CLIENT_MSG_ID.C2S_MSG_GET_REDBAG, buffer);
  }

  static msg_get_redbag_info(redbag_id) {
    var msg = new net.msg_get_redbag_info();
    msg.redbag_id = redbag_id;
    let buffer = net.msg_get_redbag_info.encode(msg).finish();
    GameSocket.instance.sendData(
      net.CLIENT_MSG_ID.C2S_MSG_GET_REDBAG_INFO,
      buffer,
    );
  }

  static msg_input_sync(chatkey, is_input) {
    var msg = new net.msg_input_sync();
    msg.chatkey = chatkey;
    msg.is_input = is_input;
    let buffer = net.msg_input_sync.encode(msg).finish();
    GameSocket.instance.sendData(net.CLIENT_MSG_ID.C2S_MSG_INPUT_SYNC, buffer);
  }

  static msg_get_online_state(uid) {
    var msg = new net.msg_get_online_state();
    msg.uid = uid;
    let buffer = net.msg_get_online_state.encode(msg).finish();
    GameSocket.instance.sendData(
      net.CLIENT_MSG_ID.C2S_MSG_GET_ONLINE_STATE,
      buffer,
    );
  }

  static msg_get_group_online(chatkey) {
    var msg = new net.msg_get_group_online();
    msg.groupkey = chatkey;
    let buffer = net.msg_get_group_online.encode(msg).finish();
    GameSocket.instance.sendData(
      net.CLIENT_MSG_ID.C2S_MSG_GET_GROUP_ONLINE,
      buffer,
    );
  }

  static msg_set_mute_notifications(chatkey, opertype) {
    var msg = new net.msg_set_mute_notifications();
    msg.chatkey = chatkey;
    msg.opertype = opertype;
    let buffer = net.msg_set_mute_notifications.encode(msg).finish();
    GameSocket.instance.sendData(
      net.CLIENT_MSG_ID.C2S_MSG_SET_MUTE_NOTIFICATIONS,
      buffer,
    );
  }

  static msg_set_chat_on_top(chatkey, opertype) {
    var msg = new net.msg_set_chat_on_top();
    msg.chatkey = chatkey;
    msg.opertype = opertype;
    let buffer = net.msg_set_chat_on_top.encode(msg).finish();
    GameSocket.instance.sendData(
      net.CLIENT_MSG_ID.C2S_MSG_SET_CHAT_ON_TOP,
      buffer,
    );
  }

  static msg_get_mute_notify_list() {
    var msg = new net.msg_get_mute_notify_list();
    let buffer = net.msg_get_mute_notify_list.encode(msg).finish();
    GameSocket.instance.sendData(
      net.CLIENT_MSG_ID.C2S_MSG_GET_MUTE_NOTIFY_LIST,
      buffer,
    );
  }

  static msg_get_chat_on_top_list() {
    var msg = new net.msg_get_chat_on_top_list();
    let buffer = net.msg_get_chat_on_top_list.encode(msg).finish();
    GameSocket.instance.sendData(
      net.CLIENT_MSG_ID.C2S_MSG_GET_CHAT_ON_TOP_LIST,
      buffer,
    );
  }

  static msg_get_offline_data() {
    var msg = new net.msg_get_offline_data();
    let buffer = net.msg_get_offline_data.encode(msg).finish();
    GameSocket.instance.sendData(
      net.CLIENT_MSG_ID.C2S_MSG_GET_OFFLINE_DATA,
      buffer,
    );
  }

  static msg_del_chat_msg(chatkey) {
    var msg = new net.msg_del_chat_msg();
    msg.chatkey = chatkey;
    let buffer = net.msg_del_chat_msg.encode(msg).finish();
    GameSocket.instance.sendData(
      net.CLIENT_MSG_ID.C2S_MSG_DEL_CHAT_MSG,
      buffer,
    );
  }

  static msg_confirm_del_msg(chatkey, chatmsgno) {
    var msg = new net.msg_confirm_del_msg();
    msg.chatkey = chatkey;
    msg.chatmsgno = chatmsgno;
    let buffer = net.msg_confirm_del_msg.encode(msg).finish();
    GameSocket.instance.sendData(
      net.CLIENT_MSG_ID.C2S_MSG_CONFIRM_DEL_MSG,
      buffer,
    );
  }

  static msg_delete_friend(frienduid) {
    var msg = new net.msg_confirm_del_msg();
    msg.frienduid = frienduid;
    let buffer = net.msg_delete_friend.encode(msg).finish();
    GameSocket.instance.sendData(
      net.CLIENT_MSG_ID.C2S_MSG_DELETE_FRIEND,
      buffer,
    );
  }

  static msg_set_sign(sign) {
    var msg = new net.msg_set_sign();
    msg.sign = StringUtils.encode(sign);
    let buffer = net.msg_set_sign.encode(msg).finish();
    GameSocket.instance.sendData(net.CLIENT_MSG_ID.C2S_MSG_SET_SIGN, buffer);
  }

  static msg_set_region(region) {
    var msg = new net.msg_set_region();
    msg.region = StringUtils.encode(region);
    let buffer = net.msg_set_region.encode(msg).finish();
    GameSocket.instance.sendData(net.CLIENT_MSG_ID.C2S_MSG_SET_REGION, buffer);
  }

  static msg_set_headurl(headurl) {
    var msg = new net.msg_set_headurl();
    msg.headurl = StringUtils.encode(headurl);
    let buffer = net.msg_set_headurl.encode(msg).finish();
    GameSocket.instance.sendData(
      net.CLIENT_MSG_ID.C2S_MSG_SET_HEADURL,
      buffer,
      IMApp.getCurTime(),
    );
  }

  static msg_set_name(nickname) {
    var msg = new net.msg_set_name();
    msg.name = StringUtils.encode(nickname);
    let buffer = net.msg_set_name.encode(msg).finish();
    GameSocket.instance.sendData(net.CLIENT_MSG_ID.C2S_MSG_SET_NAME, buffer);
  }

  static msg_set_alias(uid, alias) {
    var msg = new net.msg_set_alias();
    msg.fuid = uid;
    msg.alias = StringUtils.encode(alias);
    let buffer = net.msg_set_alias.encode(msg).finish();
    GameSocket.instance.sendData(net.CLIENT_MSG_ID.C2S_MSG_SET_ALIAS, buffer);
  }

  static msg_getalias_list() {
    var msg = new net.msg_getalias_list();
    let buffer = net.msg_getalias_list.encode(msg).finish();
    GameSocket.instance.sendData(
      net.CLIENT_MSG_ID.C2S_MSG_GET_ALIAS_LIST,
      buffer,
    );
  }

  static msg_total_redbag_record() {
    var msg = new net.msg_total_redbag_record();
    let buffer = net.msg_total_redbag_record.encode(msg).finish();
    GameSocket.instance.sendData(
      net.CLIENT_MSG_ID.C2S_MSG_TOTAL_REDBAG_RECORD,
      buffer,
    );
  }

  static msg_upload_addressbook(addressbook, is_end) {
    var msg = new net.msg_upload_addressbook();
    msg.addressbook = StringUtils.encode(addressbook);
    msg.is_end = is_end ? 1 : 0;
    let buffer = net.msg_upload_addressbook.encode(msg).finish();
    GameSocket.instance.sendData(
      net.CLIENT_MSG_ID.C2S_MSG_UPLOAD_ADDRESSBOOK,
      buffer,
    );
  }

  static msg_get_addressbook() {
    var msg = new net.msg_get_addressbook();
    let buffer = net.msg_get_addressbook.encode(msg).finish();
    GameSocket.instance.sendData(
      net.CLIENT_MSG_ID.C2S_MSG_GET_ADDRESSBOOK,
      buffer,
    );
  }

  static msg_upload_pushid(pushid, pushchannel) {
    var msg = new net.msg_upload_pushid();
    msg.pushid = StringUtils.encode(pushid);
    msg.pushchannel = pushchannel;
    let buffer = net.msg_upload_pushid.encode(msg).finish();
    GameSocket.instance.sendData(
      net.CLIENT_MSG_ID.C2S_MSG_UPLOAD_PUSHID,
      buffer,
    );
  }

  static msg_set_background(is_back) {
    var msg = new net.msg_set_background();
    msg.is_back = is_back;
    let buffer = net.msg_set_background.encode(msg).finish();
    GameSocket.instance.sendData(
      net.CLIENT_MSG_ID.C2S_MSG_SET_BACKGROUND,
      buffer,
    );
  }

  static msg_get_online_list(uids) {
    var msg = new net.msg_get_online_list();
    msg.uidlist = uids;
    let buffer = net.msg_get_online_list.encode(msg).finish();
    GameSocket.instance.sendData(
      net.CLIENT_MSG_ID.C2S_MSG_GET_ONLINE_LIST,
      buffer,
    );
  }

  static msg_joingroup_byqrcode(groupkey, otheruid, verify) {
    var msg = new net.msg_joingroup_byqrcode();
    msg.groupkey = groupkey;
    msg.otheruid = otheruid;
    msg.verify = StringUtils.encode(verify);
    let buffer = net.msg_joingroup_byqrcode.encode(msg).finish();
    GameSocket.instance.sendData(
      net.CLIENT_MSG_ID.C2S_MSG_JOINGROUP_BYQRCODE,
      buffer,
    );
  }

  /**
   * 转账
   * @param {*} target_phonenum 给谁转账
   * @param {*} trans_type 转账方式 1扫收款码转账 2直接转账 9手机号转账
   * @param {*} trans_amount 转账金额
   * @param {*} remarks 备注
   */
  static msg_transfer_account(
    target_phonenum,
    trans_type,
    trans_amount,
    remarks,
    authcode,
    cointype,
  ) {
    var msg = new net.msg_transfer_account();

    msg.target_phonenum = StringUtils.encode(
      target_phonenum ? target_phonenum : '',
    );
    msg.trans_type = trans_type;
    msg.trans_amount = trans_amount;
    msg.remarks = StringUtils.encode(remarks ? remarks : '');
    msg.authcode = authcode;
    msg.cointype = cointype;
    let buffer = net.msg_transfer_account.encode(msg).finish();
    GameSocket.instance.sendData(
      net.CLIENT_MSG_ID.C2S_MSG_TRANSFER_ACCOUNT,
      buffer,
    );
  }
  /**
   * 获取支付的授权码
   * @param {*} paypasswd
   */
  static msg_get_pay_auth_code(paypasswd) {
    var msg = new net.msg_get_pay_auth_code();
    msg.paypasswd = BinaryEncoder.fromString(paypasswd ? paypasswd : '');
    let buffer = net.msg_get_pay_auth_code.encode(msg).finish();
    GameSocket.instance.sendData(
      net.CLIENT_MSG_ID.C2S_MSG_GET_PAY_AUTH_CODE,
      buffer,
    );
  }

  /**
   * 获取账单列表
   * @param {*} uid
   */
  static msg_get_money_change_list(uid) {
    var msg = new net.msg_get_money_change_list();
    let buffer = net.msg_get_money_change_list.encode(msg).finish();
    GameSocket.instance.sendData(
      net.CLIENT_MSG_ID.C2S_MSG_GET_MONEY_CHANGE_LIST,
      buffer,
    );
  }
  /**
   * 获取我的挂单信息
   */
  static msg_get_my_goods() {
    var msg = new net.msg_get_my_goods();
    let buffer = net.msg_get_my_goods.encode(msg).finish();
    GameSocket.instance.sendData(
      net.CLIENT_MSG_ID.C2S_MSG_GET_MY_GOODS,
      buffer,
    );
  }
  /**
   * 挂单
   * @param {*} goodsvalue 挂单金额
   * @param {*} minlimit 限额最低值
   * @param {*} maxlimit 限额最高值
   * @param {*} paylist 支持的交易方式,移动支付id列表
   * @param {*} cointype 1Fb 2其他
   * @param {*} rate 汇率(放大10000倍为整数)
   * @param {*} status 状态1开启2关闭
   * @param {*} goodstype 1充值2提现3兑换
   * @param {*} outcointype 兑换的时候COIN_TYPE_RMB,兑换成什么币种
   */
  static msg_create_goods(
    goodsvalue,
    minlimit,
    maxlimit,
    paylist,
    cointype,
    rate,
    status,
    goodstype,
    outcointype,
  ) {
    var msg = new net.msg_create_goods();
    msg.goodsvalue = goodsvalue;
    msg.minlimit = minlimit;
    msg.maxlimit = maxlimit;
    msg.paylist = paylist;
    msg.cointype = cointype;
    msg.rate = rate;
    msg.status = status;
    msg.goodstype = goodstype;
    if (goodstype == 3) {
      msg.outcointype = outcointype;
    }
    // console.log('msg_create_goods--->', msg);
    let buffer = net.msg_create_goods.encode(msg).finish();
    GameSocket.instance.sendData(
      net.CLIENT_MSG_ID.C2S_MSG_CREATE_GOODS,
      buffer,
    );
  }
  /**
   * 获取所有挂单消息
   * @param {*} paytype //0银行卡1支付宝2微信
   * @param {*} opertype//1充值 2提现 3兑换
   */
  static msg_get_goods(paytype, money_type, opertype, value) {
    var msg = new net.msg_get_goods();
    msg.cointype = money_type;
    if (opertype == 3) {
      msg.outcointype = paytype;
    } else {
      msg.paytype = paytype;
    }
    msg.opertype = opertype;
    msg.value = value;
    let buffer = net.msg_get_goods.encode(msg).finish();
    // console.log('msg===1===>', msg);
    GameSocket.instance.sendData(net.CLIENT_MSG_ID.C2S_MSG_GET_GOODS, buffer);
  }
  /**
   * 创建订单
   * @param {*} opertype 1充值 2提现
   * @param {*} goodsid 选的哪个goods
   * @param {*} ordervalue 订单金额
   * @param {*} paytype 支付方式
   */
  static msg_create_order(opertype, goodsid, ordervalue, paytype) {
    var msg = new net.msg_create_order();
    msg.opertype = opertype;
    msg.goodsid = goodsid;
    msg.ordervalue = ordervalue;
    msg.paytype = paytype;
    let buffer = net.msg_create_order.encode(msg).finish();
    // console.log('msg======>', msg);
    GameSocket.instance.sendData(
      net.CLIENT_MSG_ID.C2S_MSG_CREATE_ORDER,
      buffer,
    );
  }
  /**
   * 确认订单
   * @param {*} orderid
   */
  static msg_confirm_order(orderid) {
    var msg = new net.msg_confirm_order();
    msg.orderid = orderid;
    let buffer = net.msg_confirm_order.encode(msg).finish();
    // console.log('msg======>', msg);
    GameSocket.instance.sendData(
      net.CLIENT_MSG_ID.C2S_MSG_CONFIRM_ORDER,
      buffer,
    );
  }
  /**
   * 获取我相关的订单
   */
  static msg_get_my_orders() {
    var msg = new net.msg_get_my_orders();
    let buffer = net.msg_get_my_orders.encode(msg).finish();
    // console.log('msg======>', msg);
    GameSocket.instance.sendData(
      net.CLIENT_MSG_ID.C2S_MSG_GET_MY_ORDERS,
      buffer,
    );
  }
  /**
   * 获取与某商户的订单
   * @param {*} otheruid
   */
  static msg_get_order_info(otheruid) {
    // console.log(
    //   'get_goods_detail------->44444444444444444444',
    //   '444444444444444444--------' + otheruid,
    // );
    var msg = new net.msg_get_order_info();
    msg.otheruid = otheruid;
    let buffer = net.msg_get_order_info.encode(msg).finish();
    // console.log('msg======>', msg);
    GameSocket.instance.sendData(
      net.CLIENT_MSG_ID.C2S_MSG_GET_ORDER_INFO,
      buffer,
    );
  }
  /**
   * 获取某个挂单
   * @param {*} goodsid
   */
  static msg_get_goods_byid(goodsid) {
    var msg = new net.msg_get_goods_byid();
    msg.goodsid = goodsid;
    let buffer = net.msg_get_goods_byid.encode(msg).finish();
    // console.log('msg======>', msg);
    GameSocket.instance.sendData(
      net.CLIENT_MSG_ID.C2S_MSG_GET_GOODS_BYID,
      buffer,
    );
  }

  static msg_withdraw_chatmsg(chatkey, chatmsgno) {
    var msg = new net.msg_withdraw_chatmsg();
    msg.chatkey = chatkey;
    msg.otheruid = chatmsgno;
    let buffer = net.msg_withdraw_chatmsg.encode(msg).finish();
    GameSocket.instance.sendData(
      net.CLIENT_MSG_ID.C2S_MSG_WITHDRAW_CHATMSG,
      buffer,
    );
  }

  static msg_confirm_hasread_msg(chatkey, chatmsgno_list) {
    var msg = new net.msg_confirm_hasread_msg();
    msg.chatkey = chatkey;
    msg.chatmsgno_list = chatmsgno_list;
    let buffer = net.msg_confirm_hasread_msg.encode(msg).finish();
    GameSocket.instance.sendData(
      net.CLIENT_MSG_ID.C2S_MSG_CONFIRM_HASREAD_MSG,
      buffer,
    );
  }

  static requestTimeout = null;
  static chatmsgno_list = [];
  static msg_get_hasread_list(chatkey, chatmsgno_list) {
    C2S.chatmsgno_list = chatmsgno_list;
    C2S.chatkey = chatkey;
    clearTimeout(C2S.requestTimeout);
    let fun = list => {
      var msg = new net.msg_get_hasread_list();
      msg.chatkey = chatkey;
      msg.chatmsgno_list = list;
      let buffer = net.msg_get_hasread_list.encode(msg).finish();
      GameSocket.instance.sendData(
        net.CLIENT_MSG_ID.C2S_MSG_GET_HASREAD_LIST,
        buffer,
      );
      C2S.requestTimeout = setTimeout(() => {
        if (C2S.chatmsgno_list.length > 0) {
          fun(C2S.chatmsgno_list);
        }
      }, 3000);
    };
    fun(C2S.chatmsgno_list);
  }

  static updateUnreadlist(chatkey, clientkey, chatmsgno) {
    if (C2S.chatkey != chatkey) {
      return;
    }
    for (let i = 0; i < C2S.chatmsgno_list.length; i++) {
      if (C2S.chatmsgno_list[i] == clientkey) {
        C2S.chatmsgno_list[i] = chatmsgno;
      }
    }
  }

  static cancelRequestUnread() {
    C2S.requestTimeout && clearTimeout(C2S.requestTimeout);
    C2S.requestTimeout = null;
  }

  static msg_get_group_nickname_list(groupkey) {
    var msg = new net.msg_get_group_nickname_list();
    msg.groupkey = groupkey;
    // console.log('msg_get_group_nickname_list-->', msg);
    let buffer = net.msg_get_group_nickname_list.encode(msg).finish();
    // console.log(buffer);
    GameSocket.instance.sendData(
      net.CLIENT_MSG_ID.C2S_MSG_GET_GROUP_NICKNAME_LIST,
      buffer,
    );
  }

  static msg_set_group_nickname(groupkey, nickname) {
    var msg = new net.msg_set_group_nickname();
    msg.groupkey = groupkey;
    msg.nickname = StringUtils.encode(nickname);
    let buffer = net.msg_set_group_nickname.encode(msg).finish();
    GameSocket.instance.sendData(
      net.CLIENT_MSG_ID.C2S_MSG_SET_GROUP_NICKNAME,
      buffer,
    );
  }
  /**
   * 取消订单
   * @param {} orderid
   */
  static msg_cancel_order(orderid) {
    var msg = new net.msg_cancel_order();
    msg.orderid = orderid;
    let buffer = net.msg_cancel_order.encode(msg).finish();
    GameSocket.instance.sendData(
      net.CLIENT_MSG_ID.C2S_MSG_CANCEL_ORDER,
      buffer,
    );
  }

  /**
   * 修改支付方式
   * @param {*} orderid
   * @param {*} paytype
   * @param {*} paytypeid
   */
  static msg_set_order_paytypeid(orderid, paytype, paytypeid) {
    var msg = new net.msg_set_order_paytypeid();
    msg.orderid = orderid;
    msg.paytype = paytype;
    msg.paytypeid = paytypeid;
    let buffer = net.msg_set_order_paytypeid.encode(msg).finish();
    GameSocket.instance.sendData(
      net.CLIENT_MSG_ID.C2S_MSG_SET_ORDER_PAYTYPEID,
      buffer,
    );
  }
  /**
   * 获取商品数据(今日笔数和金额)
   * @param {*} goodstype 1充值2提现
   */
  static msg_get_goods_data() {
    var msg = new net.msg_get_goods_data();
    let buffer = net.msg_get_goods_data.encode(msg).finish();
    GameSocket.instance.sendData(
      net.CLIENT_MSG_ID.C2S_MSG_GET_GOODS_DATA,
      buffer,
    );
  }
  /**
   * 查看明细
   * @param {*} goodstype 1充值2提现
   */
  static msg_get_goods_detail_data(goodstype) {
    var msg = new net.msg_get_goods_detail_data();
    msg.goodstype = goodstype;
    let buffer = net.msg_get_goods_detail_data.encode(msg).finish();
    GameSocket.instance.sendData(
      net.CLIENT_MSG_ID.C2S_MSG_GET_GOODS_DETAIL_DATA,
      buffer,
    );
  }

  /**
   * 操作商户余额
   * @param {*} opertype 1充值2提现
   * @param {*} amount
   */
  static msg_oper_shopcoin(opertype, amount, authcode, money_type) {
    var msg = new net.msg_oper_shopcoin();
    msg.opertype = opertype;
    msg.amount = amount;
    msg.authcode = authcode;
    msg.cointype = money_type;
    let buffer = net.msg_oper_shopcoin.encode(msg).finish();
    // console.log('msg_oper_shopcoin------>', msg);
    GameSocket.instance.sendData(
      net.CLIENT_MSG_ID.C2S_MSG_OPER_SHOPCOIN,
      buffer,
    );
  }

  static msg_set_snapchat(chatkey, snaptime) {
    var msg = new net.msg_set_snapchat();
    msg.chatkey = chatkey;
    msg.snaptime = snaptime;
    // console.log('msg_set_snapchat------>', msg);
    let buffer = net.msg_set_snapchat.encode(msg).finish();
    GameSocket.instance.sendData(
      net.CLIENT_MSG_ID.C2S_MSG_SET_SNAPCHAT,
      buffer,
    );
  }

  static msg_get_snap_list() {
    var msg = new net.msg_get_snap_list();
    let buffer = net.msg_get_snap_list.encode(msg).finish();
    GameSocket.instance.sendData(
      net.CLIENT_MSG_ID.C2S_MSG_GET_SNAPCHAT_LIST,
      buffer,
    );
  }

  static msg_get_screenshot(chatkey) {
    var msg = new net.msg_get_screenshot();
    msg.chatkey = chatkey;
    let buffer = net.msg_get_screenshot.encode(msg).finish();
    GameSocket.instance.sendData(
      net.CLIENT_MSG_ID.C2S_MSG_GET_SCREENSHOT,
      buffer,
    );
  }

  static msg_set_screenshot(chatkey, flag) {
    var msg = new net.msg_set_screenshot();
    msg.chatkey = chatkey;
    msg.flag = flag;
    // console.log('msg_set_screenshot----->', msg);
    let buffer = net.msg_set_screenshot.encode(msg).finish();
    GameSocket.instance.sendData(
      net.CLIENT_MSG_ID.C2S_MSG_SET_SCREENSHOT,
      buffer,
    );
  }

  static msg_set_groupsendmsg_limit(groupkey, limits) {
    var msg = new net.msg_set_groupsendmsg_limit();
    msg.groupkey = groupkey;
    msg.limits = limits;
    // console.log('msg_set_groupsendmsg_limit--->', msg);
    let buffer = net.msg_set_groupsendmsg_limit.encode(msg).finish();
    GameSocket.instance.sendData(
      net.CLIENT_MSG_ID.C2S_MSG_SET_GROUPSENDMSG_LIMIT,
      buffer,
    );
  }
  static msg_get_order_info_byid(orderid) {
    var msg = new net.msg_get_order_info_byid();
    msg.orderid = orderid;
    // console.log('msg_get_order_info_byid_req-------->2', msg);
    let buffer = net.msg_get_order_info_byid.encode(msg).finish();
    GameSocket.instance.sendData(
      net.CLIENT_MSG_ID.C2S_MSG_GET_ORDER_INFO_BYID,
      buffer,
    );
  }

  static msg_set_black_list(otheruid, opertype) {
    var msg = new net.msg_set_black_list();
    msg.otheruid = otheruid;
    msg.opertype = opertype;
    let buffer = net.msg_set_black_list.encode(msg).finish();
    GameSocket.instance.sendData(
      net.CLIENT_MSG_ID.C2S_MSG_SET_BLACK_LIST,
      buffer,
    );
  }

  static msg_get_black_list() {
    var msg = new net.msg_get_black_list();
    let buffer = net.msg_get_black_list.encode(msg).finish();
    GameSocket.instance.sendData(
      net.CLIENT_MSG_ID.C2S_MSG_GET_BLACK_LIST,
      buffer,
    );
  }

  static msg_third_pay(orderid, authcode) {
    var msg = new net.msg_third_pay();
    msg.orderid = orderid;
    msg.authcode = authcode;
    let buffer = net.msg_third_pay.encode(msg).finish();
    GameSocket.instance.sendData(net.CLIENT_MSG_ID.C2S_MSG_THIRD_PAY, buffer);
  }

  static msg_pcauth(pcflow, pckey) {
    // console.log('msg_pcauth--->', pcflow, ' ', pckey);
    var msg = new net.msg_pcauth();
    msg.pcflow = pcflow;
    msg.pckey = StringUtils.encode(pckey);
    let buffer = net.msg_pcauth.encode(msg).finish();
    GameSocket.instance.sendData(net.CLIENT_MSG_ID.C2S_MSG_PCAUTH, buffer);
  }

  static msg_voice_call(chatkey, token) {
    var msg = new net.msg_voice_call();
    msg.chatkey = chatkey;
    msg.token = StringUtils.encode(token);
    // console.log('msg_voice_call---->', msg);
    let buffer = net.msg_voice_call.encode(msg).finish();
    GameSocket.instance.sendData(net.CLIENT_MSG_ID.C2S_MSG_VOICE_CALL, buffer);
  }

  static msg_oper_voice_call(chatkey, opertype) {
    var msg = new net.msg_oper_voice_call();
    msg.chatkey = chatkey;
    msg.opertype = opertype;
    let buffer = net.msg_oper_voice_call.encode(msg).finish();
    // console.log('voice------->msg_oper_voice_call---->', msg);
    GameSocket.instance.sendData(
      net.CLIENT_MSG_ID.C2S_MSG_OPER_VOICE_CALL,
      buffer,
    );
  }

  static msg_voice_data(chatkey, voice_data) {
    // console.log('msg_voice_data--->');
    var msg = new net.msg_voice_data();
    msg.chatkey = chatkey;
    msg.voice_data = StringUtils.encode(voice_data);
    msg.ptime = Math.ceil(IMApp.getCurTime() * 1000);
    // console.log('msg.ptime -------->', msg.ptime);
    let buffer = net.msg_voice_data.encode(msg).finish();
    GameSocket.instance.sendData(net.CLIENT_MSG_ID.C2S_MSG_VOICE_DATA, buffer);
  }

  static msg_set_forbid_tm(groupkey, forbidbegintm, forbidendtm, isforbid) {
    var msg = new net.msg_set_forbid_tm();
    msg.groupkey = groupkey;
    msg.forbidbegintm = forbidbegintm;
    msg.forbidendtm = forbidendtm;
    msg.isforbid = isforbid;
    let buffer = net.msg_set_forbid_tm.encode(msg).finish();
    GameSocket.instance.sendData(
      net.CLIENT_MSG_ID.C2S_MSG_SET_FORBID_TM,
      buffer,
    );
  }

  static msg_need_read_group_notify(groupkey) {
    var msg = new net.msg_need_read_group_notify();
    msg.groupkey = groupkey;

    let buffer = net.msg_need_read_group_notify.encode(msg).finish();
    GameSocket.instance.sendData(
      net.CLIENT_MSG_ID.C2S_MSG_NEED_READ_GROUP_NOTIFY,
      buffer,
    );
  }

  static msg_read_group_notify(groupkey, notifyversion) {
    var msg = new net.msg_read_group_notify();
    msg.groupkey = groupkey;
    msg.notifyversion = notifyversion;

    let buffer = net.msg_read_group_notify.encode(msg).finish();
    GameSocket.instance.sendData(
      net.CLIENT_MSG_ID.C2S_MSG_READ_GROUP_NOTIFY,
      buffer,
    );
  }

  static msg_get_group_member_list(groupkey) {
    var msg = new net.msg_get_group_member_list();
    msg.groupkey = groupkey;
    let buffer = net.msg_read_group_notify.encode(msg).finish();
    GameSocket.instance.sendData(
      net.CLIENT_MSG_ID.C2S_MSG_GET_GROUP_MEMBER_LIST,
      buffer,
    );
  }

  /** 加入聊天室 */

  static msg_join_chatroom(roomKey) {
    var msg = new net.msg_join_chatroom();
    msg.roomkey = roomKey;
    let buffer = net.msg_join_chatroom.encode(msg).finish();
    GameSocket.instance.sendData(
      net.CLIENT_MSG_ID.C2S_MSG_JOIN_CHATROOM,
      buffer,
    );
  }

  static msg_quit_chatroom(roomKey) {
    var msg = new net.msg_quit_chatroom();
    msg.roomkey = roomKey;
    let buffer = net.msg_quit_chatroom.encode(msg).finish();
    GameSocket.instance.sendData(
      net.CLIENT_MSG_ID.C2S_MSG_QUIT_CHATROOM,
      buffer,
    );
  }

  static msg_send_chatroom_msg(roomkey, msg_type, content) {
    var msg = new net.msg_send_chatroom_msg();
    msg.roomkey = roomkey;
    msg.msg_type = msg_type;
    msg.content = StringUtils.encode(content);
    let buffer = net.msg_send_chatroom_msg.encode(msg).finish();
    GameSocket.instance.sendData(
      net.CLIENT_MSG_ID.C2S_MSG_SEND_CHATROOM_MSG,
      buffer,
    );
  }

  static msg_chatroom_kickout(roomkey, kickuid) {
    var msg = new net.msg_chatroom_kickout();
    msg.roomkey = roomkey;
    msg.kickuid = kickuid;
    let buffer = net.msg_chatroom_kickout.encode(msg).finish();
    GameSocket.instance.sendData(
      net.CLIENT_MSG_ID.C2S_MSG_CHATROOM_KICKOUT,
      buffer,
    );
  }

  static msg_chatroom_forbid(roomkey, uid, is_set) {
    var msg = new net.msg_chatroom_forbid();
    msg.roomkey = roomkey;
    msg.uid = uid;
    msg.is_set = is_set;
    let buffer = net.msg_chatroom_forbid.encode(msg).finish();
    GameSocket.instance.sendData(
      net.CLIENT_MSG_ID.C2S_MSG_CHATROOM_FORBID,
      buffer,
    );
  }

  static msg_chatroom_admin(roomkey, uid, is_set) {
    var msg = new net.msg_chatroom_admin();
    msg.roomkey = roomkey;
    msg.uid = uid;
    msg.is_set = is_set;
    let buffer = net.msg_chatroom_admin.encode(msg).finish();
    GameSocket.instance.sendData(
      net.CLIENT_MSG_ID.C2S_MSG_CHATROOM_SET_ADMIN,
      buffer,
    );
  }

  static msg_del_chatroom_msg(roomkey, msgno) {
    var msg = new net.msg_del_chatroom_msg();
    msg.roomkey = roomkey;
    msg.msgno = msgno;
    let buffer = net.msg_del_chatroom_msg.encode(msg).finish();
    GameSocket.instance.sendData(
      net.CLIENT_MSG_ID.C2S_MSG_DEL_CHATROOM_MSG,
      buffer,
    );
  }


  static msg_get_chatroom_list() {
    var msg = new net.msg_get_chatroom_list();
    let buffer = net.msg_get_chatroom_list.encode(msg).finish();
    GameSocket.instance.sendData(
      net.CLIENT_MSG_ID.C2S_MSG_GET_CHATROOM_LIST,
      buffer,
    );
  }

  static msg_get_chatroom_members(roomkey, page, limit) {
    var msg = new net.msg_get_chatroom_members();
    msg.roomkey = roomkey;
    msg.page = page;
    msg.limit = limit;
    let buffer = net.msg_get_chatroom_members.encode(msg).finish();
    GameSocket.instance.sendData(
      net.CLIENT_MSG_ID.C2S_MSG_GET_CHATROOM_MEMBERS,
      buffer,
    );
  }

  // static msg_join_chatroom(roomkey) {
  //   var msg = new net.msg_join_chatroom();
  //   msg.roomkey = roomkey;
  //   let buffer = net.msg_join_chatroom.encode(msg).finish();
  //   GameSocket.instance.sendData(
  //     net.CLIENT_MSG_ID.C2S_MSG_JOIN_CHATROOM,
  //     buffer,
  //   );
  // }

  // static msg_quit_chatroom(roomkey) {
  //   var msg = new net.msg_quit_chatroom();
  //   msg.roomkey = roomkey;
  //   let buffer = net.msg_quit_chatroom.encode(msg).finish();
  //   GameSocket.instance.sendData(
  //     net.CLIENT_MSG_ID.C2S_MSG_QUIT_CHATROOM,
  //     buffer,
  //   );
  // }

}
